// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"3b53517f","68":"3b53517f","854":"3b53517f"}[chunkId] + ".chunk.css";
};